import Translator from '../Translator';

export const Home = () => {
    return (
     <>
        <Translator />       
     </>
    );
};

export default Home;